import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/FeedActivitiesSlice';
import { CompaniesPulse } from 'Types/FeedActivitiesTypes';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state?.feedActivities || initialState;
export const selectactivityLoading = createSelector(
  [selectDomain],
  (state) => state.activitiesLoading,
);
export const selectactivityLoaded = createSelector(
  [selectDomain],
  (state) => state.activitiesLoaded,
);
export const selectAllArticles = createSelector([selectDomain], (state) => state.allArticles);
export const selectPage = createSelector([selectDomain], (state) => state.allTabPage);
export const selectArticlesEnded = createSelector([selectDomain], (state) => state.articlesEnded);
export const selectedNewsArticles = createSelector([selectDomain], (state) => state.newsArticles);
export const newsLoading = createSelector([selectDomain], (state) => state.newsLoading);
export const selectNewsLoaded = createSelector([selectDomain], (state) => state.newsLoaded);
export const selectCurrentSections = createSelector(
  [selectDomain],
  (state) => state.currentSections,
);
export const selectNewsPage = createSelector([selectDomain], (state) => state.newsTabPage);
export const selectedNewsArticlesEnded = createSelector(
  [selectDomain],
  (state) => state.articlesNewsEnded,
);
export const selectedSocialArticles = createSelector(
  [selectDomain],
  (state) => state.socialArticles,
);
export const selectedSocialPage = createSelector([selectDomain], (state) => state.socialTabPage);
export const selectedSocialArticlesEnded = createSelector(
  [selectDomain],
  (state) => state.articlesSocialEnded,
);
export const selectedSocialFilter = createSelector(
  [selectDomain],
  (state) => state.selectedSocialFilter,
);
export const selectedPaginationLoading = createSelector(
  [selectDomain],
  (state) => state.paginationLoader,
);
export const socialLoading = createSelector([selectDomain], (state) => state.socialsLoading);
export const newsFilter = createSelector([selectDomain], (state) => state.newsFilter);
export const selectedNewsFilter = createSelector(
  [selectDomain],
  (state) => state.selectedNewsFilter,
);
export const socialFilter = createSelector([selectDomain], (state) => state.socialFilters);
export const selectFeedBoardPulseLoading = createSelector(
  [selectDomain],
  (state) => state.feedBoardPulseLoading,
);
export const selectFeedBoardPulseData = createSelector(
  [selectDomain],
  (state) => state.feedBoardPulseData as CompaniesPulse,
);

export const selectAllActivitiesFlurry = createSelector(
  [selectDomain],
  (state) => state.allFlurry,
);

export const selectNewsActivitiesFlurry = createSelector(
  [selectDomain],
  (state) => state.newsFlurry,
);

export const selectSocialActivitiesFlurry = createSelector(
  [selectDomain],
  (state) => state.socialFlurry,
);

export const selectAllActivitiesCall = createSelector(
  [selectDomain],
  (state) => state.AllActivitiesApiCall,
);

export const selectNewsActivitiesCall = createSelector(
  [selectDomain],
  (state) => state.newsActivitiesApiCall,
);

export const selectSocialActivitiesCall = createSelector(
  [selectDomain],
  (state) => state.socialActivitiesApiCall,
);
